import {
  Align,
  Arrange,
  Button,
  Spacer,
  SvgChevronDown,
  SvgStar,
  Text,
  TextButton,
} from '@loomhq/lens';
import React from 'react';
import { useDispatch } from 'react-redux';

import { SHOW_GET_STARTED_CHECKLIST } from 'constants/triggers';
import { completeTriggerCreator } from 'creators/triggers';

import ChecklistTask from './ChecklistTask';
import GetStartedProgressBar from './ProgressBar';

import styles from './OpenChecklist.module.less';

export default function OpenChecklist({
  openTaskId,
  currentTaskId,
  closeChecklist,
  openTask,
  tasks,
  animatedTaskId,
}) {
  const dispatch = useDispatch();

  const onDimissChecklist = () => {
    dispatch(completeTriggerCreator(SHOW_GET_STARTED_CHECKLIST));
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className="p:medium">
          <div className={styles.headerButton}>
            <TextButton
              icon={<SvgChevronDown />}
              onClick={closeChecklist}
              iconPosition="right"
            >
              Get started checklist
            </TextButton>
          </div>
          <Spacer top="small" />
          <GetStartedProgressBar tasks={tasks} />
        </div>
      </div>
      <div className={styles.tasks}>
        <ol>
          {tasks.map(task => (
            <li className="block" key={task.id}>
              <ChecklistTask
                task={task}
                animated={task.id === animatedTaskId}
                title={task.title}
                isCurrent={currentTaskId === task.id}
                isComplete={task.isComplete}
                isOpen={task.id === openTaskId}
                onOpen={() => openTask(task.id)}
                onClose={() => openTask(null)}
              >
                {task.cta || null}
              </ChecklistTask>
            </li>
          ))}
        </ol>
        {!currentTaskId && (
          <div className={styles.allComplete}>
            <Align placement="center">
              <Arrange
                alignItems="center"
                justifyContent="center"
                gap="medium"
                autoFlow="row"
              >
                <div className={styles.starIcon}>
                  <SvgStar />
                </div>
                <Text size="large" fontWeight="black" color="grey7">
                  Ready for prime time!
                </Text>
                <Align placement="center">
                  <Button onClick={onDimissChecklist}>Dismiss checklist</Button>
                </Align>
              </Arrange>
            </Align>
          </div>
        )}
      </div>
    </div>
  );
}
